export const SERVICE_TYPE = {
  AIS_DEPRECATED: 'verifications',
  AIS: 'ais',
  PIS: 'payments',
} as const;

export const getServiceType = () => {
  const chunks = (new URL(document.URL).pathname ?? '').split('/');

  if (chunks.includes(SERVICE_TYPE.AIS_DEPRECATED)) {
    return SERVICE_TYPE.AIS_DEPRECATED;
  }

  if (chunks.includes(SERVICE_TYPE.AIS)) {
    return SERVICE_TYPE.AIS;
  }

  return SERVICE_TYPE.PIS;
};

export const CURRENT_SERVICE_TYPE = getServiceType();
